import { HttpParams } from '@angular/common/http';

export const convertFindQueryToHttpParams = (query: object): HttpParams => {
  let params = new HttpParams();
  Object.keys(query)
    .filter((key) => (query as never)[key] !== undefined)
    .forEach((key) => {
      const value = (query as never)[key];
      if (Array.isArray(value)) {
        (value as Array<string>).forEach(
          (val) => (params = params.append(key, val))
        );
      } else {
        params = params.append(key, value);
      }
    });
  return params;
};
